import { MOBILE_ACTION_CODE } from '@mobileTypes'

/**
 * Defines the result structure for each mobile action type
 * Used to provide type hints for previousResult in dependent actions
 */
export const MOBILE_ACTION_RESULT_TYPES: Record<MOBILE_ACTION_CODE, {
  type: string;
  fields?: { name: string; type: string; description: string }[]
}> = {
  [MOBILE_ACTION_CODE.GET_CURRENT_POSITION]: {
    type: 'object',
    fields: [
      { name: 'latitude', type: 'number', description: 'GPS latitude coordinate (-90 to 90)' },
      { name: 'longitude', type: 'number', description: 'GPS longitude coordinate (-180 to 180)' },
      { name: 'accuracy', type: 'number', description: 'Position accuracy in meters (lower = more accurate)' },
      { name: 'altitude', type: 'number', description: 'Altitude in meters above sea level (may be null)' },
      { name: 'altitudeAccuracy', type: 'number', description: 'Altitude accuracy in meters (-1 if unavailable)' },
      { name: 'heading', type: 'number', description: 'Direction of travel in degrees (0-360, -1 if unavailable)' },
      { name: 'speed', type: 'number', description: 'Speed in meters per second (-1 if unavailable)' },
    ],
  },
  [MOBILE_ACTION_CODE.EXECUTE_COMMAND]: {
    type: 'any',
  },
  [MOBILE_ACTION_CODE.EXECUTE_JS]: {
    type: 'any',
  },
  [MOBILE_ACTION_CODE.NAVIGATE]: {
    type: 'void',
  },
  [MOBILE_ACTION_CODE.CHANGE_VARIABLE_VALUE]: {
    type: 'void',
  },
  [MOBILE_ACTION_CODE.START_INTERVAL]: {
    type: 'object',
    fields: [
      { name: 'intervalId', type: 'string', description: 'Timer identifier that was started' },
      { name: 'started', type: 'boolean', description: 'Whether timer was successfully started' },
    ],
  },
  [MOBILE_ACTION_CODE.STOP_INTERVAL]: {
    type: 'object',
    fields: [
      { name: 'intervalId', type: 'string', description: 'Timer identifier that was stopped' },
      { name: 'stopped', type: 'boolean', description: 'Whether timer was successfully stopped' },
    ],
  },
  [MOBILE_ACTION_CODE.OPEN_SHEET]: {
    type: 'void',
  },
  [MOBILE_ACTION_CODE.CLOSE_SHEET]: {
    type: 'void',
  },
  [MOBILE_ACTION_CODE.CONDITION]: {
    type: 'void',
  },
}
